import { MedicalCodeControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

interface useUpdateCataLogCodeParams {
  medicalCodeId: string;
  archive?: boolean;
  xTENANTID?: string;
}

/**
 * @author rajkumar rathod
 */
export const useArchiveCatalogCode = () =>
  useMutationWithLoading(async (params: useUpdateCataLogCodeParams) =>
    new MedicalCodeControllerApi(
      getConfigObject()
    ).updateMedicalCodeArchiveStatus(
      params.medicalCodeId,
      params?.archive ?? true, //may req for undo delete
      params.xTENANTID
    )
  );
